import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import browserHistory from 'components/utility/history';
import { ContentLoading, ErrorPage } from 'axway-react-ui';
import ModelDesignInitiator from './ModelDesignInitiator';
import ModelSummaryView from '../view/ModelSummaryView';
import * as actions from '../actions';

class ModelSummary extends React.Component {
	constructor(props) {
		super(props);
		this.onEdit = this.onEdit.bind(this);
		this.onCompose = this.onCompose.bind(this);
	}

	onEdit() {
		const name = encodeURIComponent(this.props.model.name);
		browserHistory.push(`${window.$conf.prefix}/project/models/${name}/edit`);
	}

	/**
	 * On view just navigate straight to the model summary page.
	 */
	onViewModel(model) {
		const name = encodeURIComponent(model);
		browserHistory.push(`${window.$conf.prefix}/project/models/${name}`);
	}

	onCompose() {
		this.props.actions.designModel({
			mode: 'compose',
			modelParent: this.props.model,
			modelSource: null,
			queryState: true
		});
	}

	render() {
		const { error, errorDetail, model, models } = this.props;
		if (error) {
			return (
				<ErrorPage errorDetail={errorDetail} />
			);
		} else if (model && models) {
			return (
				<div>
					<ModelDesignInitiator />
					<ModelSummaryView
						models={models}
						model={model}
						onEdit={this.onEdit}
						onCompose={this.onCompose}
						onViewModel={this.onViewModel}
					/>
				</div>
			);
		}
		return <ContentLoading />;
	}
}

function mapDispatchToProps(dispatch) {
	return {
		actions: bindActionCreators(actions, dispatch)
	};
}

function mapStateToProps(state) {
	return {
		error: state.models.error,
		errorDetail: state.models.errorDetail,
		model: state.models.model,
		models: state.models.models || {}
	};
}

export default connect(
	mapStateToProps,
	mapDispatchToProps
)(ModelSummary);
